import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet-async";

const PaymentCancel: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Helmet>
        <title>Payment Cancelled - BuildWithChrist.ai</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="max-w-md w-full text-center space-y-6">
        <div className="h-20 w-20 rounded-full bg-muted flex items-center justify-center mx-auto">
          <XCircle className="h-12 w-12 text-muted-foreground" />
        </div>
        
        <h1 className="text-3xl font-bold font-display">Payment Cancelled</h1>
        
        <p className="text-lg text-muted-foreground">
          No worries! Your payment was not processed. You can try again whenever you're ready.
        </p>

        <div className="bg-card border border-border rounded-xl p-6 text-left space-y-3">
          <h3 className="font-semibold">Have questions?</h3>
          <p className="text-sm text-muted-foreground">
            If you encountered any issues or have questions about sponsorship, 
            please don't hesitate to reach out to us.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Button asChild>
            <Link to="/sponsors">
              Try Again <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/">Return Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
